export const USERS_API_URL = process.env.REACT_APP_USERS_API_URL;
export const DEVICE_INFO_API_URL = process.env.REACT_APP_DEVICE_INFO_API_URL;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const DOMAIN = process.env.REACT_APP_DOMAIN;
export const OPS_SERVICE_API_URL = process.env.REACT_APP_OPS_SERVICE_API_URL
export const LEO_DASHBOARD=process.env.REACT_APP_LEO_DASHBOARD
export const CHARLES_DASHBOARD=process.env.REACT_APP_CHARLES_DASHBOARD
export const REBECCA_DASHBOARD=process.env.REACT_APP_REBECCA_DASHBOARD
export const SOFIA_DASHBOARD=process.env.REACT_APP_SOFIA_DASHBOARD